<template>
    <section class="c-login-page c-stretch-page u-flex-set u-flex--content-center u-flex--align-items-center">
        <div>
            <form action="" class="c-form c-form--horizontal">

                <div class="o-page-row--medium u-text-align-center"><router-link to="/"><img class="[ c-logo ]" src="@/assets/images/logo.png" width="170px" height="79px"/></router-link></div>

                <h1 class="u-text-align-center">{{ $t('customer.account.reset.title') }}</h1>
                <p>{{ $t('customer.account.reset.description') }}</p>

                <v-form-row>
                    <v-input v-model="Password" name="password1" type="password" :fluid="true" :error="Validate.Password">
                        <slot slot="label">{{ $t('customer.account.reset.new_password') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <v-input v-model="ConfirmPassword" type="password" name="password2" :fluid="true">
                        <slot slot="label">{{ $t('customer.account.register.confirm_password') }}</slot>
                    </v-input>
                </v-form-row>

                <v-form-row>
                    <div v-if="InvalidPassword" class="u-color-error-base" style="padding-left: 247px; padding-top: 5px;">
                        {{ $t('customer.account.reset.invalid') }}
                    </div>
                </v-form-row>

                <v-form-row>
                    <div class="c-form-item" style="padding-left: 247px">
                        <button :disabled="SendDisabled" @click.prevent="submitForm" class="c-button c-button--alpha">{{ $t('customer.account.register.submit') }}</button>
                    </div>
                </v-form-row>
            </form>
        </div>
        <notifications group="global" position="bottom right">
                <template slot="body" slot-scope="props">
                    <div class="c-notification" :class="props.item.type">
                        <svgicon name="check" v-if="props.item.type === 'success'"></svgicon>
                        <div>
                            <p class="c-notification__title">{{props.item.title}}</p>
                            <div class="c-notification__text" v-html="props.item.text"></div>
                        </div>
                        <button type="button" class="c-notification__close c-button--reset c-button--icon u-flex--push-left" @click="props.close">
                            <svgicon name="close"></svgicon>
                        </button>
                    </div>
                </template>
            </notifications>
    </section>
</template>

<script>
    // Forms
    import debounce from 'lodash/debounce'
    import VInput from '@/components/form/Input'
    import VFormRow from '@/components/form/Row'

    export default {
        components: {
            VInput,
            VFormRow,
        },
        data() {
            return {
                Password: null,
                ConfirmPassword: null,
                Code: null,
                InvalidPassword: false,
                SendDisabled: true,
                Validate: {}
            }
        },
        created() {
            this.Code = this.$route.query.code,
            this.UserId = this.$route.query.userId
        },
        watch: {
            Email: debounce(function() {
                this.InvalidEmail = !this.validEmail(this.Email);
            }, 500),
            Password: debounce(function() {
                this.comparePassword();
            }, 500),
            ConfirmPassword: debounce(function() {
                this.comparePassword();
            }, 500)
        },
        methods: {
            validateForm(response){
                let errors = response.ModelState;
                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });
                this.Validate = errors;
            },
            comparePassword() {
                if(this.Password && this.ConfirmPassword){
                    this.SendDisabled = this.Password != this.ConfirmPassword;
                    this.InvalidPassword = this.Password != this.ConfirmPassword;
                }
            },
            submitForm(e) {
                this.SendDisabled = true;

                this.$store.dispatch('resetPassword', {
                    UserId: this.UserId,
                    Password: this.Password,
                    Code: this.Code 
                }).then((response) => {
                    this.SendDisabled = false;
                    this.$notify({
                        group: 'global',
                        title: 'Uw wachtwoord is succesvol gewijzigd.',
                        type: 'success',
                        duration: 4000
                    });
                    this.$router.push("/login");
                }).catch(e => {
                    this.SendDisabled = false;
                    this.validateForm(e);
                });
                e.preventDefault();
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

    .c-login-page {
        background-color: white;
    }

    .c-login-block {
        width: 100%;
        max-width: em(400px);
    }
</style>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-stretch-page {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/common/PasswordReset.vue